<template>
  <div id="app" class="noselect">
    <Calc />
  </div>
</template>

<script>
import Calc from "./components/Calc.vue";

export default {
  name: "App",
  components: {
    Calc,
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap");

* {
  font-family: "Fjalla One", sans-serif;
  color: #d8f1f5;
  // border: 1px solid yellow;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

#app {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: #21212c;
}
</style>
